import {AuthApiService} from "base/api/service";
import ServiceUtil from "base/api/utilities/ServiceUtil";
import {createEntityService} from "base/entity/service";
import {
    createPermit,
    createPermits,
    permit_api_adapter,
    permits_api_adapter,
} from "permit/model";
import {createViolations, violations_api_adapter} from "violation/model";

const basePath = "/api/app/permits";

const entityService = createEntityService(
    basePath,
    createPermit,
    createPermits,
    permit_api_adapter,
    permits_api_adapter
);

const PermitService = {
    getList(filter, sort, order, format = null) {
        return entityService.getList(filter, null, sort, order, null, format);
    },

    getPaginatedList(filter, page, sort, order) {
        return entityService.getList(filter, page, sort, order);
    },

    getFeatures(filter) {
        return entityService.getFeatures(filter);
    },

    getBySearchText(searchText) {
        return entityService.getBySearchText(searchText);
    },

    get(id) {
        return entityService.get(id);
    },

    getViolations(permitId) {
        return AuthApiService.get(`${basePath}/${permitId}/violations/`).then(
            response => {
                return createViolations(violations_api_adapter(response));
            }
        );
    },

    create(permit) {
        return entityService.create(permit);
    },

    update(permit) {
        return entityService.update(permit);
    },

    extendTrees(id, trees) {
        return AuthApiService.post(`${basePath}/${id}/extend_trees/`, trees);
    },

    extendMaterials(id, materials) {
        return AuthApiService.post(`${basePath}/${id}/extend_materials/`, materials);
    },

    canBeDeleted(id) {
        return entityService.canBeDeleted(id).then(response => {
            if (response.result === "success") {
                return [true, ""];
            }
            return [false, response.detail];
        });
    },

    delete(id) {
        return entityService.delete(id);
    },

    returnToProcess(id) {
        return AuthApiService.put(`${basePath}/${id}/status/`, {
            data: "return_to_process",
        }).then(response => {
            return createPermit(permit_api_adapter(response));
        });
    },

    getExport(filter) {
        const baseUrl = "/api/app/permits/export";
        const url = `${baseUrl}/?${ServiceUtil.getFilterQueryString(filter)}`;
        return AuthApiService.get(url).then(response => {
            return response;
        });
    },
};

export default PermitService;
